import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./responsive-layout.css.ts.vanilla.css-mistica.js";
var n = {
    inverse: "_1y2v1nf39",
    alternative: "_1y2v1nf3e"
}, v = "_1y2v1nfbs", e = "_17lofg76 _1y2v1nfbs", o = "_17lofg74";
export { n as backgroundVariant, v as container, e as fullWidth, o as responsiveLayout };
